import { Locale } from 'modules/i18n';

export const headerTranslation = {
  [Locale.en]: {
    statistics: 'Statistics',
  },
};
